import { Box, Button } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledButton = styled(Button)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  padding: "15px",
  justifyContent: "space-between",
  backgroundColor: (theme.palette as any).foreground.inverted,
  alignItems: "center",
  borderRadius: "10px",
  boxShadow: "0px 0px 16px 0px #0000001A",
  textAlign: "center",
  marginBottom: "2px",
  "&:hover": {
    backgroundColor: (theme.palette as any).foreground.inverted,
    boxShadow: "-8px 8px 16px 0px #0000001A"
  }
}))

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  marginLeft: theme.spacing(2),
  borderRadius: "100px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "28px",
  minWidth: "28px"
}))
